import { InputText } from "primereact/inputtext";
import React from "react";

interface DataListModalSearchProps {
    inputId?: string;
    value: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    disabled?: boolean;
    inputClassName?: string;
    placeholder: string;
    showClear?: boolean;
    onClear?: () => void;
}

const DataListModalSearch: React.FC<DataListModalSearchProps> = ({
    inputId,
    value,
    onChange,
    disabled,
    inputClassName,
    placeholder,
    showClear = true,
    onClear
}) => {
    return (
        <div className="data_search_input_area">
            <InputText
                id={inputId}
                value={value}
                onChange={onChange}
                className={`custom_form_input data_search_input ${inputClassName ?? ''}`}
                placeholder={placeholder}
                autoComplete="off"
                autoFocus
                type={"search"}
                disabled={disabled}
            />
            
            {value === "" ? (
                <i className="bi bi-search"></i>
            ) : (
                <React.Fragment>
                    {showClear ? (
                        <i
                            className="bi bi-x-lg data_search_input_clear"
                            onClick={(onClear)}
                        ></i>
                    ) : (
                        <i className="bi bi-search"></i>
                    )}
                </React.Fragment>
            )}
        </div>
    )
}

export default DataListModalSearch;